"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isBindingConstraintsWithTag = isBindingConstraintsWithTag;
function isBindingConstraintsWithTag(tag, value) {
    return (constraints) => constraints.tags.has(tag) && constraints.tags.get(tag) === value;
}
//# sourceMappingURL=isBindingConstraintsWithTag.js.map